import type { IDeepLink } from '@erp/native/interfaces';

/**
 * Web has no native deep-link concept — these are just URLs. We still
 * implement the interface so the React layer doesn't need to know.
 */
export function createWebDeepLink(): IDeepLink {
  return {
    onOpen() {
      return () => {};
    },
  };
}
